
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.
module.exports = require("./lib/d3-scale");



//////////////////
// WEBPACK FOOTER
// ./~/victory-vendor/d3-scale.js
// module id = 236
// module chunks = 0